import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RepaymentTriggers from "@/pages/tools/RepaymentTriggers";

export const Route = createFileRoute("/tools/repayment-triggers")({
  head: () => seoHead("/tools/repayment-triggers"),
  component: RepaymentTriggers,
});
